import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("da_token") || null);
  const [username, setUsername] = useState(localStorage.getItem("da_user") || null);
  const [loading, setLoading] = useState(true);

  const logout = useCallback(() => {
    localStorage.removeItem("da_token");
    localStorage.removeItem("da_user");
    setToken(null);
    setUsername(null);
  }, []);

  useEffect(() => {
    let active = true;
    const check = async () => {
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        const { data } = await api.get("/auth/me");
        if (active) setUsername(data.username);
      } catch (e) {
        if (active) logout();
      } finally {
        if (active) setLoading(false);
      }
    };
    check();
    return () => {
      active = false;
    };
  }, [token, logout]);

  const login = async (u, p) => {
    const { data } = await api.post("/auth/login", { username: u, password: p });
    localStorage.setItem("da_token", data.token);
    localStorage.setItem("da_user", data.username);
    setToken(data.token);
    setUsername(data.username);
    return data;
  };

  return (
    <AuthContext.Provider value={{ token, username, loading, login, logout, isAuthed: !!token }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
